/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthEventHandlerService {
  constructor(private publicEventsService: PublicEventsService, private authService: AuthService) {}

  public initEventHandler() {
    console.log('Initialize authorization event handler...');

    this.publicEventsService
      .registerForEvents()
      .pipe()
      .subscribe((value) => {
        switch (value.type) {
          case EventTypes.UserDataChanged:
            this.authService.setUserData(value.value.userData);
            break;
          case EventTypes.NewAuthenticationResult:
            this.authService.setAuthenticationResult(value.value);
            break;
        }
      });
  }
}
